import React from 'react';
import './MainHeader.css';
import Typewriter from "typewriter-effect";
import tanjin from '../../../images/me1.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const MainHeader = () => {

    return (
        <div className="developer raw">
            <div className="col-md-6 text-center p-5 mt-5" data-aos="zoom-in-down">
                <div className="mt-md-5 pt-md-5">
                    <div>
                        <h1 className="text-dark display-3 font-weight-bold"><span className="hello"><span className="hi">H</span>ello, I'm</span>Tanjin</h1>
                    </div>
                    <h1 className="text-amination">

                        <Typewriter
                            options={{
                                strings: ["JavaScript Developer", "Front-end Developer", "MERN Developer", "Programmer"],
                                autoStart: true,
                                loop: true,
                                delay: 30
                            }}
                        />

                    </h1>
                    <div className="pl-md-5 text-center text-dark">
                        <p className="text-center" style={{ fontSize: "1.2rem", color: "rgba(10, 10, 10, 0.924)" }}>A self-motivated and enthusiastic web developer with a deep interest in JavaScript. To work in the Software industry with modern web technologies of different local & multinational Software/ IT agencies of Bangladesh and grow rapidly with increasing responsibilities.</p>
                    </div>
                    <div class="text-center mt-5">
                        <a className="btn text-center m-2 dwnBtn" href="https://drive.google.com/u/0/uc?id=1TqW3EQ6VaasxqP108gMQVV_jy9wwd6Gw&export=download"><FontAwesomeIcon icon={faDownload} /> Resume</a>
                        <Link to="/contact" className="btn text-center dwnBtn">Contact Me</Link>

                    </div>
                </div>
            </div>
            <div className="col-md-6" data-aos="fade-left">
                <div className="mt-md-5 d-flex justify-content-center align-items-center">
                    <img className="img-fluid d-block me1" src={tanjin} alt="" />
                </div>

            </div>
        </div>
    );
};

export default MainHeader;